import { render, staticRenderFns } from "./VoteBoardLeftBar.vue?vue&type=template&id=94c1db22&scoped=true"
import script from "./VoteBoardLeftBar.vue?vue&type=script&lang=js"
export * from "./VoteBoardLeftBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c1db22",
  null
  
)

export default component.exports